import { on, each } from '../helpers/shortcuts';
import S from './shared';
import scrollIt from '../helpers/scroll-it';

export default () => {
  const homeSlides = document.querySelector('.c-home-slides');

  if (homeSlides === null) {
    return;
  }

  homeSlides.classList.add('is-controlled');

  const slides = homeSlides.querySelectorAll('.c-home-slides__slide');
  const container = homeSlides.querySelector('.c-home-slides__inner');
  const slidesData = [];
  const dots = homeSlides.querySelectorAll('.o-dots__button');
  let nextBlockTop = 0;
  let currentSlide = 0;
  let animating = false;
  let currentPadding = 0;
  const scrollTime = 1000;
  const scrollEase = 'easeOutCubic';
  let rafRef = null;

  const setSlide = index => {
    if (index > -1 && index < slides.length) {
      each(dots, dot => dot.classList.remove(S.CSS.active));
      dots[index].classList.add(S.CSS.active);
    }

    currentSlide = index;

    if (currentSlide < slides.length - 1) {
      homeSlides.classList.remove('is-last');
    } else {
      homeSlides.classList.add('is-last');
    }
  };

  const updateBlocksData = () => {
    let top = homeSlides.offsetTop + S.adminBarHeight;

    each(slides, (slide, index) => {
      const rect = slide.getBoundingClientRect();
      slidesData[index].top = top;
      slidesData[index].height = rect.height;
      slidesData[index].visible = slidesData[index].height > 0;
      slidesData[index].bottom = rect.height + top;

      top += rect.height;
    });

    nextBlockTop = top;
  };

  const checkBlock = () => {
    const top = S.scrollTop + S.getHeaderHeight() + S.adminBarHeight;
    let index = 0;

    for (; index < slides.length; index += 1) {
      if (
        slidesData[index].visible &&
        top < slidesData[index].bottom &&
        top >= slidesData[index].top
      ) {
        if (index !== currentSlide) {
          setSlide(index);
        }
        return;
      }
    }

    setSlide(index);
  };

  const checkPositions = () => {
    const bottom = S.scrollTop + S.windowHeight;
    const top = S.scrollTop + S.getHeaderHeight() + S.adminBarHeight;

    let padding = 0;
    for (let i = 0; i < slides.length; i += 1) {
      const slide = slides[i];
      const data = slidesData[i];

      if (!data.visible) {
        // eslint-disable-next-line no-continue
        continue;
      }

      if (data.bottom <= bottom) {
        padding += data.height;

        if (!data.isFixed) {
          slide.classList.add('is-fixed');
        }

        data.isFixed = true;
      } else {
        if (data.isFixed) {
          slide.classList.remove('is-fixed');
        }
        data.isFixed = false;
      }

      if (i < slides.length - 1) {
        const percentage = Math.min(
          1,
          Math.max((top - data.top) / (data.height * 0.75), 0),
        );

        slide.style.opacity = 1 - percentage;
      }
    }

    if (currentPadding !== padding) {
      currentPadding = padding;
      container.style.paddingTop = `${currentPadding}px`;
    }

    rafRef = null;
  };

  const goToSlide = index => {
    if (animating) {
      return;
    }

    animating = true;
    const top =
      index < slides.length
        ? slidesData[index].top - S.getHeaderHeight()
        : nextBlockTop - S.getHeaderHeight();
    scrollIt(top - S.adminBarHeight, scrollTime, scrollEase, () => {
      setSlide(index);
      setTimeout(() => {
        animating = false;
      }, 10);
    });
  };

  const next = homeSlides.querySelector('.c-home-slides__next');

  on('click', next, event => {
    event.preventDefault();
    goToSlide((currentSlide + 1) % (slides.length + 1));
  });

  each(slides, () => {
    slidesData.push({ isFixed: false });
  });

  each(dots, (dot, index) => {
    on('click', dot, event => {
      event.preventDefault();
      goToSlide(index);
    });
  });

  const collectAllData = () => {
    updateBlocksData();
    checkBlock();
    checkPositions();
  };

  collectAllData();

  const resizeTimeout = null;

  on('resize load', window, () => {
    clearTimeout(resizeTimeout);

    setTimeout(collectAllData, 100);
  });

  on('scroll', window, () => {
    checkBlock();

    if (rafRef === null) {
      rafRef = requestAnimationFrame(checkPositions);
    }
  });

  on(
    'wheel',
    document.documentElement,
    event => {
      if (S.isOverlay === true) {
        return;
      }

      if (currentSlide <= slides.length && !S.isWheelScrolling && !animating) {
        if (Math.abs(event.deltaY) < 1) {
          event.preventDefault();
        } else if (
          event.deltaY < 0 &&
          (currentSlide < slides.length ||
            Math.abs(nextBlockTop - S.scrollTop) < 100)
        ) {
          goToSlide(Math.max(currentSlide - 1, 0));
        } else if (event.deltaY > 0 && currentSlide < slides.length) {
          goToSlide(Math.min(currentSlide + 1, slides.length));
        }
      }

      if (animating) {
        event.preventDefault();
      }
    },
    S.hasPassiveEvents ? { passive: false } : undefined,
  );
};



// WEBPACK FOOTER //
// ./src/scripts/modules/home-slides.js